import { useNavigate } from 'react-router-dom';

type LegalSection = {
  title: string;
  body: string;
};

type LegalPageProps = {
  title: string;
  subtitle: string;
  updatedAt: string;
  intro: string;
  sections: LegalSection[];
};

export default function LegalPage({ title, subtitle, updatedAt, intro, sections }: LegalPageProps) {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F7F4ED] text-navy">
      <header className="border-b border-gold/20 bg-white">
        <div className="mx-auto flex max-w-5xl items-center justify-between px-6 py-5">
          <button onClick={() => navigate('/')} className="flex cursor-pointer items-center gap-3">
            <img
              src="https://static.readdy.ai/image/7e0624576d141773c913eba1868f652c/ea02af35c9a274d0014fddb0274b3cab.png"
              alt="Foi Senegal"
              className="h-10 w-10 rounded-xl bg-white object-contain"
            />
            <span className="text-lg font-bold">Foi Senegal</span>
          </button>
          <button
            onClick={() => navigate('/')}
            className="cursor-pointer rounded-lg border border-navy/20 px-4 py-2 text-sm font-semibold text-navy transition-colors hover:bg-navy hover:text-white"
          >
            Accueil
          </button>
        </div>
      </header>

      <main className="mx-auto max-w-5xl px-6 py-12">
        <p className="mb-3 text-sm font-semibold uppercase tracking-wider text-gold-dark">{updatedAt}</p>
        <h1 className="max-w-3xl text-4xl font-black leading-tight md:text-5xl">{title}</h1>
        <p className="mt-4 max-w-3xl text-lg leading-8 text-gray-600">{subtitle}</p>

        <section className="mt-10 rounded-lg bg-white p-6 shadow-sm ring-1 ring-navy/10">
          <p className="text-base leading-8 text-gray-700">{intro}</p>
        </section>

        <div className="mt-8 space-y-5">
          {sections.map((section) => (
            <section key={section.title} className="rounded-lg bg-white p-6 shadow-sm ring-1 ring-navy/10">
              <h2 className="text-xl font-extrabold text-navy">{section.title}</h2>
              <p className="mt-3 whitespace-pre-line text-base leading-8 text-gray-700">{section.body}</p>
            </section>
          ))}
        </div>

        <p className="mt-10 text-sm text-gray-500">
          Contact officiel : <a className="font-semibold text-navy underline" href="mailto:foisenegal@gmail.com">foisenegal@gmail.com</a>
        </p>
      </main>
    </div>
  );
}
